module.exports = __webpack_public_path__ + "static/media/bulbIcon.9fc20ffb.svg";